import React from 'react'

/** Otwiera popup "brak dostępnych magazynów" - udostępniane przez PlaceMapData */
const UnavailablePopupContext = React.createContext<(() => void) | undefined>(undefined)

export default UnavailablePopupContext
